import {
    FormField
} from "@maysoft/common-component-react"
import {
    Grid,
    IconButton,
    InputAdornment,
    Paper
} from "@mui/material"
import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import { useState } from "react"
import Strings from "constants/strings"

type TelegramConfig = {
    BotToken: string
    BotUserName: string
    HostAddress: string
    DefaultChatId: string
}

type Props = {
    value: TelegramConfig
    onChange: (val: TelegramConfig) => void
}

const TelegramConfigForm = ({ value, onChange }: Props) => {

    const [showToken, setShowToken] = useState(false)

    const handleChange = (
        key: keyof TelegramConfig,
        val: string
    ) => {
        onChange({
            ...value,
            [key]: val
        })
    }

    return (
        <Paper
            sx={{
                p: 2,
                borderRadius: 2
            }}
        >
            <Grid container spacing={2}>
                {/* Bot Token */}
                <Grid item xs={12}>
                    <FormField
                        label={Strings.SETTING.TELEGRAM_CONFIG.BOT_TOKEN}
                        type={showToken ? "text" : "password"}
                        value={value.BotToken}
                        onChangeValue={(val) =>
                            handleChange("BotToken", val)
                        }
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() =>
                                            setShowToken(!showToken)
                                        }
                                    >
                                        {showToken ? (
                                            <VisibilityOffIcon />
                                        ) : (
                                            <VisibilityIcon />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>

                {/* Bot Username */}
                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.TELEGRAM_CONFIG.BOT_USERNAME}
                        value={value.BotUserName}
                        onChangeValue={(val) =>
                            handleChange("BotUserName", val)
                        }
                        fullWidth
                    />
                </Grid>

                {/* Host Address */}
                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.TELEGRAM_CONFIG.HOST_ADDRESS}
                        value={value.HostAddress}
                        onChangeValue={(val) =>
                            handleChange("HostAddress", val)
                        }
                        fullWidth
                    />
                </Grid>

                {/* Default Chat ID */}
                <Grid item xs={12}>
                    <FormField
                        label={Strings.SETTING.TELEGRAM_CONFIG.DEFAULT_CHAT_ID}
                        value={value.DefaultChatId}
                        onChangeValue={(val) =>
                            handleChange("DefaultChatId", val)
                        }
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default TelegramConfigForm